import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import Swal from 'sweetalert2';

// Set on a request that shows its own error message (e.g. the session sign-in dialog)
// so this interceptor does not open a second popup over it.
export const SKIP_ERROR_POPUP = new HttpContextToken<boolean>(() => false);

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  // const router = inject(Router);

  return next(req).pipe(
    catchError((error) => {
      if (req.context.get(SKIP_ERROR_POPUP)) {
        return throwError(() => error);
      }
      const status = error?.status;
      const title = error?.error?.error || 'Error';
      const message = error?.error?.message || 'Something went wrong. Please try again.';

      console.error('HTTP Error:', error);

      // 🔕 Let auth interceptor handle token errors
      if (status === 401 || status === 403) {
        return throwError(() => error);
      }

      // 🌐 Network / CORS error
      if (status === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Network Error',
          text: 'Unable to reach server. Please check your internet connection.',
          confirmButtonColor: '#B5325E',
        });
        return throwError(() => error);
      }

      // 🚫 Known backend error codes
      if ([404, 405, 500, 870].includes(status)) {
        Swal.fire({
          icon: 'error',
          title,
          text: message,
          confirmButtonColor: '#B5325E',
        });
        return throwError(() => error);
      }

      // ❓ Fallback
      Swal.fire({
        icon: 'error',
        title: 'Unexpected Error',
        text: message,
        confirmButtonColor: '#B5325E',
      });

      return throwError(() => error);
    })
  );
};
